// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2qRaR","alert":"SettungsInbox_alert__31EzU"};